import * as React from "react";
import { buildUrl } from "../../core/routes";
import { PollinatorIcon } from "./pollinator-icon";
import { NavigationItem } from "@atlassiansox/microscopekit";

export function pollinatorUrl(serviceId: string) {
  return buildUrl("https://pollinator.prod.atl-paas.net/checks", {
    search: serviceId
  });
}

export class PollinatorNavigationLinks extends React.Component<{ id: string }> {
  render() {
    return (
      <NavigationItem
        icon={PollinatorIcon}
        text="Pollinator"
        isCompact={true}
        href={pollinatorUrl(this.props.id)}
      />
    );
  }
}
